<mat-sidenav-container
  class="mainWrapper"
  autosize
  autoFocus
  [ngClass]="{
  'sidebarNav-mini': options.sidenavCollapsed && options.navPos !== 'top' &&  !resView,
  'sidebarNav-horizontal': options.horizontal,
  cardBorder: options.cardBorder,
}"
  [dir]="options.dir!">
  <!-- ============================================================== -->
  <!-- Vertical Sidebar -->
  <!-- ============================================================== -->
  @if (!options.horizontal) {
    <mat-sidenav
      #leftsidenav
      [mode]="isOver ? 'over' : 'side'"
      [opened]="
      options.navPos === 'side' && options.sidenavOpened && !isOver && !resView"
      (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      >
      <div class="flex-layout">
        <app-sidebar (toggleMobileNav)="sidenav.toggle()" [showToggle]="isOver"></app-sidebar>
        <ng-scrollbar class="position-relative" style="height: 100%">
          <mat-nav-list class="sidebar-list">
            @for (item of navItems; track item) {
              <app-nav-item [item]="item" (notify)="sidenav.toggle()"></app-nav-item>
            }
          </mat-nav-list>
        </ng-scrollbar>
      </div>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- horizontal Sidebar -->
  <!-- ============================================================== -->
  @if (resView) {
    <mat-sidenav #leftsidenav [mode]="'over'" [opened]="options.sidenavOpened && !isTablet"
      (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav" >
      <app-sidebar></app-sidebar>
      <ng-scrollbar class="position-relative" style="height: 100%">
        <mat-nav-list class="sidebar-list">
          @for (item of navItems; track item) {
            <app-nav-item [item]="item" (notify)="sidenav.toggle()"></app-nav-item>
          }
        </mat-nav-list>
      </ng-scrollbar>
    </mat-sidenav>
  }

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="contentWrapper" #content>
    <!-- ============================================================== -->
    <!-- VerticalHeader -->
    <!-- ============================================================== -->
    @if (!options.horizontal) {
      <app-header
        [showToggle]="!isOver"
        (toggleCollapsed)="toggleCollapsed()"
        (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="filterNavRight.toggle()"
        (optionsChange)="receiveOptions($event)"></app-header>
    } @else {
      <!-- horizontal header -->
      <app-horizontal-header
        (toggleMobileNav)="sidenav.toggle()"
        (toggleMobileFilterNav)="filterNavRight.toggle()"
        (optionsChange)="receiveOptions($event)"></app-horizontal-header>
    }
    @if (options.horizontal) {
      <app-horizontal-sidebar></app-horizontal-sidebar>
    }
    <div class="body-wrapper">
      <main
        class="pageWrapper"
        [ngClass]="{
          maxWidth: options.boxed
        }">
        <app-breadcrumb></app-breadcrumb>
        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </main>
    </div>
  </mat-sidenav-content>

</mat-sidenav-container>

<!-- ------------------------------------------------------------------
  Assistente virtuale (visibile in tutte le pagine autenticate)
  ------------------------------------------------------------------ -->
<app-chatbot></app-chatbot>

<!-- ------------------------------------------------------------------
  Mobile Apps Sidebar
  ------------------------------------------------------------------ -->
<mat-drawer #filterNavRight mode="over" position="end" class="filter-sidebar">
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="branding">
        <app-branding></app-branding>
      </div>
      <button mat-icon-button (click)="filterNavRight.toggle()" class="d-flex justify-content-center">
        <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
      </button>
    </div>
    <mat-accordion>
      <mat-expansion-panel class="shadow-none">
        <mat-expansion-panel-header>
          <mat-panel-title class="f-s-16 f-w-500"> Apps</mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="row">
            @for (appdd of apps; track appdd.title) {
              <div class="col-12 text-hover-primary">
                <a [routerLink]="[appdd.link]" class="d-flex align-items-center text-decoration-none m-b-24 gap-16">
                <span
                  class="text-{{ appdd.color }} bg-light-{{appdd.color}} rounded icon-48 d-flex align-items-center justify-content-center">
                  <span class="iconify icon-20" [attr.data-icon]="appdd.icon"></span>
                </span>
                  <div class="m-l-16">
                    <h5 class="f-s-14 f-w-600 m-0 hover-text">
                      {{ appdd.title }}
                    </h5>
                    <span class="f-s-12 text-muted">{{ appdd.subtitle }}</span>
                  </div>
                </a>
              </div>
            }
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-drawer>

